/* eslint-disable react-hooks/exhaustive-deps */
import { Provider, useDispatch, useSelector } from "react-redux";
import "./App.css";
import { PageRoutes } from "./PageRouting";
import store from "./store";
import { getDataFromLocal, saveLoggedUser } from "./Redux/actions/AuthActions";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, onForegroundMessage } from "./config/firebase";
import { collection, deleteDoc, doc, getDocs, onSnapshot, query, serverTimestamp, updateDoc, where } from "firebase/firestore";
import IncomingCallModal from "./Pages/IncomingCallModal";
import { convertUTCDate } from "./utils/convertionFunc";
import AppointmentService from "./Services/AppointmentService";
import { APP_ROUTES } from "./PageRouting/pageRoutes";
import { setSelectedAppt } from "./Redux/actions/appointmentActions";

function App() {
  const dispatch = useDispatch();
  const [incomingData, setIncomingData] = useState([]);
  const navigate = useNavigate();
  const { loggedUser } = useSelector((state) => state.auth);
  const { selectedAppt } = useSelector((state) => state.appt);

  useEffect(() => {
    if (!loggedUser) {
      const loggedUserObj = localStorage.getItem("patientData");
      const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;
      dispatch(saveLoggedUser(loggedUser));
    }
  }, [loggedUser]);

  useEffect(() => {
    const patientId = loggedUser?.patientId;
    if (!patientId) return;

    const callsRef = collection(db, "calls");

    const q = query(
      callsRef,
      where("incomingCall.receiverId", "==", patientId),
      where("incomingCall.status", "==", 1)
    );

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      if (snapshot.empty) {
        localStorage.removeItem("incoming");
        localStorage.removeItem("incomingModal");
        setIncomingData([]);
        return;
      }

      const calls = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setIncomingData(calls);
      localStorage.setItem("incoming", JSON.stringify(calls));
      localStorage.setItem("incomingModal", "true");
    });

    return () => unsubscribe();
  }, [loggedUser, selectedAppt]);

  const handleAcceptCall = async (roomId) => {
    if (!roomId) return;
    const roomObj = incomingData?.find((item) => item.incomingCall.roomId === roomId)?.incomingCall;
    localStorage.setItem("callRoomId", roomObj.roomId);

    // Clear record from firebase
    // await deleteFirebaseCallRecord(callerId);
    await updateDoc(doc(db, "calls", roomId), {
      "incomingCall.status": 2, // in call
      "incomingCall.acceptedAt": serverTimestamp()
    });


    // Navigate to call
    const currentDate = new Date();
    const formattedDate = convertUTCDate(currentDate, "YYYY-MM-DD HH:mm:ss");
    const payload = {
      appointmentId: roomObj.roomId
    }
    const res = await AppointmentService.getPatientAppointment(payload);
    const details = res.data[0];
    dispatch(setSelectedAppt(details));
    if (details.serviceCode !== "APPT_VIDEO") {
      return;
    }

    try {
      let payload1 = {
        patientName: details?.patientName,
        personType: "Patient",
        appointmentId: details.appointmentId,
        modifiedBy: details.userId,
        modifiedDate: formattedDate,
        patientId: details.patientId,
        queueStatus: "Y",
        userId: details.userId,
        joiningDateTime: formattedDate,
      };
      await AppointmentService.callQueueUpdate(payload1);
      // Clear popup
      const updatedState = incomingData?.filter(item => item.incomingCall.roomId !== roomId) || [];
      if (updatedState?.length === 0) {
        localStorage.removeItem("incoming");
        localStorage.removeItem("incomingModal");
      }
      else {
        localStorage.setItem("incoming", JSON.stringify(updatedState));
      }
      setIncomingData((prevState) => prevState?.filter(item => item.incomingCall.roomId !== roomId));
      navigate(APP_ROUTES.VIDEOCALL, {
        state: { selectedAppDetails: details },
      });
    } catch (error) {
      console.error("Error updating appointment or queue:", error);
    }
  };

  const handleRejectCall = async (roomId) => {
    if (!roomId) return;
    // await deleteFirebaseCallRecord(callerId);
    await updateDoc(doc(db, "calls", roomId), {
      "incomingCall.status": -1,
      "incomingCall.endedAt": serverTimestamp()
    });

    const updatedState = incomingData?.filter(item => item.incomingCall.roomId !== roomId) || [];
    if (updatedState?.length === 0) {
      localStorage.removeItem("incoming");
      localStorage.removeItem("incomingModal");
    }
    else {
      localStorage.setItem("incoming", JSON.stringify(updatedState));
    }

  };

  const deleteFirebaseCallRecord = async (callerId) => {
    if (!callerId) return;

    try {
      await deleteDoc(doc(db, "calls", callerId));
      setIncomingData(prev =>
        prev.filter(item => item.incomingCall.callerId !== callerId)
      );
    }
    catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    dispatch(getDataFromLocal());
  }, [dispatch]);

  return (
    <>
      <PageRoutes />
      <IncomingCallModal
        data={incomingData}
        onAccept={handleAcceptCall}
        onReject={handleRejectCall}
      />
    </>
  );
}

export default App;
